export default __webpack_public_path__ + "static/work-avatar-2ab97db0cdff0345c617ea6226f4bb9d.jpg";